import React, { useEffect, useState } from 'react';

const FilterValueLabel = ({
  filterType,
  filterValue,
  updateValueToFilters,
  isApplied,
  appliedFilters,
}) => {
  const [isChecked, setIsChecked] = useState(isApplied);

  useEffect(() => {
    const isPresent =
      appliedFilters &&
      appliedFilters.find(each => each.name === filterType.attr);
    if (isPresent) {
      let check = appliedFilters.find(
        each =>
          each.name === filterType.attr && each.value === filterValue.value
      );
      // console.log(check,'check')
      if (check !== undefined) setIsChecked(true);
      else setIsChecked(false);
    } else {
      setIsChecked(false);
    }
  }, [appliedFilters]);
  return (
    <div
      className={isChecked ? 'filter-value-label active' : 'filter-value-label'}
      style={{
        backgroundColor: isChecked ? '#E5F5FD' : 'white',
        color: isChecked ? '#009FE7' : 'black',
      }}
      onClick={() => {
        return updateValueToFilters(
          filterType.name,
          filterType.attr,
          filterValue.value,
          isChecked
        );
      }}
    >
      <label>{filterValue.value}</label>
    </div>
  );
};

export default FilterValueLabel;
